import { CustomIconProps } from './index';

export const NewIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
            viewBox="0 0 24 24">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <g
                fill={color || 'black'}
                fillRule="evenodd"
                clipPath="url(#prefix__clip0)"
                clipRule="evenodd">
                <path d="M13 6h-2v5H6v2h5v5h2v-5h5v-2h-5V6z" />
                <path d="M16.95 8.464L15.536 7.05 12 10.586 8.464 7.05 7.05 8.464 10.586 12 7.05 15.536l1.414 1.414L12 13.414l3.536 3.536 1.414-1.414L13.414 12l3.536-3.536z" />
            </g>
            <defs>
                <clipPath id="prefix__clip0">
                    <path
                        fill="#fff"
                        d="M0 0h16v16H0z"
                        transform="translate(4 4)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
